import { formatResource, PreDefinedResourceFormat } from "components/Translations/AppResources";
import * as React from "react";
import { useTranslation } from 'react-i18next';

export type SystemMessages =
    | "ApprovalProcessFailed"
    | "AgreementSignFailed"
    | "AgreementStampExpires"
    | "AuthenticationFailed"
    | "CourseEditPermissionDenied"
    | "CourseEnrollmentNotFound"
    | "CourseListEmpty"
    | "GeneralError"
    | "LoadGraphDataFailed"
    | "LoadListDataFailed"
    | "LoadPageDataFailed"
    | "OperationFailed"
    | "PublicationEditPermissionDenied"
    | "PublicationEditPollRestricted"
    | "PublicationNotFound"
    | "PublicationRegistered"
    | "PublicationUpdated"
    | "PublicationDraftRegistered"
    | "PublicationRegisteredWithApproval"
    | "PublicationViewPermissionDenied"
    | "TopicListEmpty"
    | "TopicNotFound"
    | "TopicPermissionDenied"
    | "UserNotFound"
    | "UserListEmpty"
    ;

export interface ISystemMessagesProps {
    resource: SystemMessages;
    formatParameters?: Array<any> | PreDefinedResourceFormat;
}

const AppMessage: React.FC<ISystemMessagesProps> = (props) => {
    const { t } = useTranslation();
    var res = t(`Message.${props.resource}`);
    if (res && props.formatParameters) res = formatResource(res, props.formatParameters);
    return (<span>{res || "?"}</span>);
};

export default AppMessage;
